import React from 'react';
import '../styles/sections/iconsWithText.scss';

function iconsWithText(props) {
    const data = props.data.blocks;
  return (
    <div className="iconsWithText">
        <div className="innerBox">    
            <h3 className="sectionHeading">{ props.data.title }</h3> 
            <ul>
                {data.map((d, index) => 
                    <li key={index}>
                        {d.src}
                        <span dangerouslySetInnerHTML={{ __html: d.title }} />
                    </li>
                )}       
            </ul>             
        </div>
    </div>
  )
};

export default iconsWithText; 